// api/progress.ts — student progress summary for the Home screen.
import { apiJson } from './client';

export interface DailyActivity {
  date:            string;         // YYYY-MM-DD (UTC)
  allenaSessions:  number;
  simulaSessions:  number;
  simulaBestScore: number | null;
}

export interface ProgressSummary {
  totalAnswered:     number;
  correctAnswered:   number;
  bestSimulaScore:   number | null;
  /** Finalized simulas (>=30 answered events), all time. Sim-KPI round 2026-07-13. */
  simulaCount:       number;
  /** Average correct-count across those, rounded to nearest int; null when none. */
  simulaAvgScore:    number | null;
  topArgomento:      string | null;
  lastActiveAt:      string | null;
  sessionsThisWeek:  number;
  currentStreakDays: number;
  longestStreakDays: number;
  activeToday:       boolean;
  recentActivity:    DailyActivity[];
}

export const progressApi = {
  async summary(): Promise<ProgressSummary> {
    return apiJson<ProgressSummary>('/api/progress/summary', { method: 'GET' });
  },
};
